import { CreateActionButton } from "./CreateActionButton";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): las acciones del panel de
// "sin resultados" cuando la pantalla admite limpiar filtros ("Limpiar
// filtros" + el botón "Nuevo…") eran el mismo marcado palabra por palabra en
// rewards/RewardsScreen.tsx y offers/OffersScreen.tsx. Extracción sin cambio
// de comportamiento ni de valores visuales: ninguna pantalla que la use
// cambia un pixel por esto.
export function EmptyResultsActions({
  hasAny,
  onClearFilters,
  onCreate,
  createLabel,
}: {
  hasAny: boolean;
  onClearFilters: () => void;
  onCreate: () => void;
  createLabel: string;
}) {
  return (
    <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
      {hasAny ? (
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          onClick={onClearFilters}
        >
          Limpiar filtros
        </button>
      ) : null}
      <CreateActionButton label={createLabel} onClick={onCreate} />
    </div>
  );
}
